import * as INR from "../INR.ts";
import * as libLocation from "../lib/location.ts";
import * as Html from "../util/Html.ts";
import * as Screen from "../lib/Screen.ts";
import { ListCache } from "../lib/SyncCache.ts";

export class ControllerBook<T extends {metaId?:string}>{
  freshGetter : ListCache<T>
  onRefresh : (items : T[])=>void

  constructor(
    NODE_LEFT :HTMLElement,
    TPL_LEFT:MUS,
    NODE_RIGHT:HTMLElement,
    TPL_RIGHT:MUS,
    TPL_RIGHT_EMPTY:MUS,
    freshGetter :ListCache<T>,
    leftRewriter = (a :T[])=>{return {items:a}}
  ){
    this.freshGetter = freshGetter;
    var
      rightUpdater;
    if(Screen.isMobileView()){
      rightUpdater = async function(targetId){
        await freshGetter.need()
        var target = freshGetter.get(targetId);
        NODE_RIGHT.classList.toggle('open',!!targetId)
        if(target){
          Html.setHtml(
            NODE_RIGHT,
            TPL_RIGHT,
            target
          );
        }
      }
    }else{
      rightUpdater = async function(targetId){
        if(!targetId){
          if(TPL_RIGHT_EMPTY){
            Html.setHtml(NODE_RIGHT,TPL_RIGHT_EMPTY,{})
          }
        }else{
          await freshGetter.need()
          Html.setHtml(
            NODE_RIGHT,
            TPL_RIGHT,
            freshGetter.get(targetId)
          );
        }
      }
    }

    function highlightSelected(targetId :string){
      NODE_LEFT.querySelectorAll("[data-fw-onclick='controllerselect']").forEach(function(node){
        node.classList.toggle("selected",Html.getDomMetaId(node)===targetId);
      });
    }

    INR.subscribe("handleParam",async ()=>{
      const targetId  = this.findItem(await this.freshGetter.need(),libLocation.getURLParam("metaId"))
      highlightSelected(targetId);
      rightUpdater(targetId);

    });
    this.onRefresh = async (allitems)=>{
      Html.setHtml(NODE_LEFT,TPL_LEFT,await leftRewriter(allitems));

      const targetId = this.findItem(allitems,libLocation.getURLParam("metaId"))


      highlightSelected(targetId);
      rightUpdater(targetId);
    }
    freshGetter.need().then(this.onRefresh)
  }
  findItem(allitems,targetId :string){
    if(allitems.length===0){
      return undefined;
    }else{
      if(allitems.find(item=>item.metaId===targetId)===undefined){
        if(Screen.isMobileView()){
          return undefined;
        }else if(Array.isArray(allitems)){
          return allitems[0].metaId;
        }else{
          return allitems.getDefaultItem().metaId;
        }
      }
      return targetId;
    }
  }

  async refresh(){
     return this.freshGetter.refresh().then(this.onRefresh)
  }
  select(metaId :string){
    libLocation.goTo('?metaId='+metaId,!Screen.isMobileView());
  }
}

export class SimpleControllerBook{
  onRefresh : (items : any[])=>void
  constructor(NODE_LEFT :HTMLElement,leftUpdater,leftDataCache,NODE_RIGHT:HTMLElement,rawRightUpdater){
    var targetId,rightUpdater;
    if(Screen.isMobileView()){
      rightUpdater = function(){
        NODE_RIGHT.classList.toggle('open',!!targetId)
        rawRightUpdater(targetId)
      }
    }else{
      rightUpdater = rawRightUpdater
    }

    function highlightSelected(){
      NODE_LEFT.querySelectorAll("[data-fw-onclick='controllerselect']").forEach(function(node){
        
        node.classList.toggle("selected",Html.getDomMetaId(node)===targetId);
      });
    }

    INR.subscribe("handleParam",()=>{
      var newTargetId = libLocation.getURLParam("metaId");
      if(newTargetId!==targetId){
        targetId = newTargetId;
        highlightSelected();
        rightUpdater(targetId);
      }

    });
    this.onRefresh = async function(allitems){
      await leftUpdater(allitems);
      if(allitems.length===0){
        targetId = undefined;
      }else{
        if(allitems.find(item=>item.metaId===targetId)===undefined){
          if(Screen.isMobileView()){
            targetId = undefined;
          }else if(Array.isArray(allitems)){
            targetId = allitems[0].metaId;
          }else{
            targetId = allitems.getDefaultItem().metaId;
          }
        }
      }

      highlightSelected();
      await rightUpdater(targetId);
    }
    this.refresh = async ()=>{
      this.onRefresh(await leftDataCache.refresh())
    }
    leftDataCache.need().then(this.onRefresh)
  }

}



Html.registerDom({
  controllerselect(metaId = Html.getDomMetaId(this)){

    libLocation.goTo('?metaId='+metaId,!Screen.isMobileView());
  }
})